/**
 * `HTMLMediaElement.play()` rejects with an AbortError when the pending request
 * is superseded by a new load()/pause() (e.g. autoplay racing the initial
 * source load). That's an expected browser race, not a real failure — swallow it
 * so it doesn't pollute the console and Datadog RUM, but still surface anything else.
 */
export function logVideoPlayError(error: unknown) {
    if (error instanceof DOMException && error.name === "AbortError") return;
    console.error(error);
}
